import Button from '@/components/core/Button/Button';
import { FormInput } from '@/components/core/FormInput/FormInput';
import { useClient } from '@/components/shared/utilities/AppProvider/AppProvider';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { FieldValues, useForm } from 'react-hook-form';

interface IResetPasswordForm extends FieldValues {
	password: string;
}

export const ResetPasswordForm: FC = () => {
	const { t } = useTranslation();
	const client = useClient();
	const router = useRouter();

	const {
		register,
		handleSubmit,
		setError,
		formState: { errors, isSubmitting },
	} = useForm<IResetPasswordForm>({ mode: 'onBlur' });

	const onSubmit = async (data) => {
		try {
			await client.update('user/passwords', {
				...data,
				resetPasswordToken: router.query.reset_password_token,
			});

			router.replace(
				{
					pathname: router.pathname,
					query: { open: 'login' },
				},
				undefined,
				{ shallow: true }
			);
		} catch (e) {
			setError(
				'password',
				{
					type: 'custom',
					message: `${t('invalid-reset-password-token')}!`,
				},
				{ shouldFocus: false }
			);
		}
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<fieldset>
				<label htmlFor="password">{`${t('new-password')}:`}</label>

				<FormInput
					autoComplete="off"
					type="password"
					placeholder={t('enter-new-password')}
					showError={Boolean(errors.password)}
					{...register('password', {
						required: 'Required',
						minLength: {
							value: 8,
							message: t('password-min-error'),
						},
						maxLength: {
							value: 72,
							message: t('password-max-error'),
						},
					})}
				/>
				{errors.password && <div className="error">{errors.password.message}</div>}
			</fieldset>
			<Button color={Button.color.PRIMARY} submit block loading={isSubmitting}>
				{t('reset-password')}
			</Button>
		</form>
	);
};
